import { StyledEmptyState, StyledEmptyStateContent } from './EmptyState.style';
import ImgEmptyState from './ra-empty-state.svg';
import ImgComputerDude from './computer-dude.svg';
import Text from 'components/base/Text';

export const EMPTY_STATE_MODULES = {
  RESOURCE_ALLOCATION: 'Resource Allocation',
  INVESTMENT_CARVING: 'Investment Carving'
};

const EmptyState = ({ module = EMPTY_STATE_MODULES.RESOURCE_ALLOCATION }) => {
  return (
    <StyledEmptyState>
      <StyledEmptyStateContent>
        <aside>
          <img src={ImgEmptyState} />
        </aside>
        <main>
          <img src={ImgComputerDude} />
          <Text className='primary'>
            Nothing to show here...
            <br />
            For now
          </Text>
          <Text className='secondary'>
            Still crunching data; it usually takes 24 hours for {module} to
            populate.
          </Text>
        </main>
      </StyledEmptyStateContent>
    </StyledEmptyState>
  );
};

export default EmptyState;
